/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { RingLoader } from "react-spinners";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const Spinner = () => {
  return (
    <div
      css={css`
        display: flex;
        width: 100vw;
        height: 80vh;
        justify-content: center;
        align-items: center;
      `}
    >
      <RingLoader css={override} sizeUnit={"rem"} size={3} color={"#f7c02d"} />
    </div>
  );
};

export default Spinner;
